<template>
  <p class="control has-icons-left">
    <input ref="datePicker" :name="fieldName" class="input" v-model="date" type="text" :disabled="disabled" autocomplete="off" @input="onInput(index)">
    <b-icon icon="calendar" class="is-small is-left" custom-size="mdi-24px"></b-icon>
  </p>
</template>

<script>
  import flatpickr from "flatpickr";
  import { Japanese } from "flatpickr/dist/l10n/ja.js"

  export default {
    name: "DatePicker",
    props: {
      fieldName: {
        type: String,
        default: 'date',
      },
      dateProvided: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      index: {
        type: Number,
        default: 0,
      },
      enableTime: {
        type: Boolean,
        default: false,
      },
      minDate: {
        default: null,
      },
      maxDate: {
        default: null,
      }
    },
    data() {
      return {
        fp: null,
        date: null,
      }
    },
    mounted() {
      this.$nextTick(() => {
        let dateFormat = 'Y-m-d'
        if (this.enableTime)
          dateFormat += ' h:i K'

        this.fp = flatpickr(this.$refs.datePicker, {
          locale: Japanese,
          enableTime: this.enableTime,
          dateFormat: dateFormat,
          defaultDate: this.dateProvided,
          minDate: this.minDate,
          maxDate: this.maxDate,
        });
      })
    },
    methods: {
      onInput(index) {
        this.$emit('input', this.date, index)
      }
    },
    watch: {
      dateProvided (newValue) {
        if (this.fp)
          this.fp.setDate(newValue)
      }
    }
  }
</script>

<style scoped>

</style>
